import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LanguageService } from './language.service';

@Injectable()
export class LanguageHttpInterceptor implements HttpInterceptor {
  constructor(private languageService: LanguageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Non aggiunge il parametro lang per richieste a file locali (assets)
    if (req.url.startsWith('assets/') || req.url.startsWith('/assets/')) {
      return next.handle(req);
    }

    // Non aggiunge il parametro lang per richieste esterne (con protocollo http/https completo)
    // a meno che non sia una chiamata API al backend
    const isExternalUrl = req.url.startsWith('http://') || req.url.startsWith('https://');
    const isBackendApi = isExternalUrl && (
      req.url.includes('api.') || 
      req.url.includes('/api/') ||
      req.url.includes('lambda')
    );

    // Se è una richiesta esterna non backend, non aggiunge lang
    if (isExternalUrl && !isBackendApi) {
      return next.handle(req);
    }

    // Ottiene la lingua corrente
    const currentLang = this.languageService.getCurrentLanguage();

    // Clona la richiesta aggiungendo il parametro lang
    let modifiedReq = req;

    // Aggiunge lang come parametro query se non è già presente
    if (!req.params.has('lang')) {
      modifiedReq = req.clone({
        params: req.params.set('lang', currentLang)
      });
    }

    return next.handle(modifiedReq);
  }
}
